import React, { useContext } from 'react';
import cn from 'classnames';
import { getDataTestId, createPaddingStyle } from '../../../../shared/esm';
import { SystemMessageContext } from '../../Context.js';

var desktopStyles = {"component":"system-message__component_2n44i"};
require('./desktop.css');

var styles = {"component":"system-message__component_174x4"};
require('./index.css');

var mobileStyles = {"component":"system-message__component_zf1ln"};
require('./mobile.css');

var DEFAULT_DESKTOP_PADDING = { bottom: 16 };
var DEFAULT_MOBILE_PADDING = { bottom: 12 };
var Title = function (_a) {
    var _b;
    var _c = _a.tag, tag = _c === void 0 ? 'h3' : _c, className = _a.className, children = _a.children, paddingProp = _a.padding;
    var _d = useContext(SystemMessageContext), dataTestId = _d.dataTestId, view = _d.view;
    var padding = paddingProp !== null && paddingProp !== void 0 ? paddingProp : (view === 'mobile' ? DEFAULT_MOBILE_PADDING : DEFAULT_DESKTOP_PADDING);
    var Component = tag;
    return (React.createElement(Component, { className: cn(styles.component, className, (_b = {},
            _b[desktopStyles.component] = view === 'desktop',
            _b[mobileStyles.component] = view === 'mobile',
            _b)), "data-test-id": getDataTestId(dataTestId, 'title'), style: createPaddingStyle(padding) }, children));
};

export { Title };
